<template>
  <div>
  </div>
</template>
<script>


import {getPreviewInfoFromToken} from "@/api/login";

export default {
  components: {
  },
  data() {
    return {
      token: '',
    };
  },
  methods: {
    initPermission() {
      getPreviewInfoFromToken({"token": this.token}).then(res => {
        if(res.resp_code !== 1) {
          this.$store.dispatch("user/Login", res).then(resLogin => {
            this.$router.push({path: '/mainpage'})
          });
        }
      });
    },
  },
  async created() {
    this.token=this.$route.query.token
    this.initPermission();
  },
};
</script>
